/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MenuOrderStatus = {
    CART: 'CART',
    CHECKOUT: 'CHECKOUT',
    PAYMENT: 'PAYMENT',
    ERROR_PAYMENT: 'ERROR_PAYMENT',
    PAID: 'PAID',
    PROCESSING: 'PROCESSING',
    RECEIVED: 'RECEIVED',
    DELIVERY_SERVICE: 'DELIVERY_SERVICE',
    DRIVER_ASSIGNED: 'DRIVER_ASSIGNED',
    DRIVER_PICKUP: 'DRIVER_PICKUP',
    OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
    DRIVER_AT_DESTINATION: 'DRIVER_AT_DESTINATION',
    DELIVERED: 'DELIVERED',
    PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
    CUSTOMER_PICKUP: 'CUSTOMER_PICKUP',
    CUSTOMER_PICKED_UP: 'CUSTOMER_PICKED_UP',
    OPEN_ISSUE: 'OPEN_ISSUE',
    RESOLVED: 'RESOLVED',
    ERROR_DEVOUR: 'ERROR_DEVOUR',
    ERROR_DEVOURIQ: 'ERROR_DEVOURIQ',
    ERROR_RESTAURANT: 'ERROR_RESTAURANT',
    ERROR_DELIVERY: 'ERROR_DELIVERY',
    SYSTEM_CANCELLED: 'SYSTEM_CANCELLED',
    CUSTOMER_CANCELLED: 'CUSTOMER_CANCELLED',
    CHAT_INITIATED: 'CHAT_INITIATED',
    REFUNDED: 'REFUNDED',
    AUTO_REFUNDED: 'AUTO_REFUNDED',
    SHIPPED: 'SHIPPED'
} as const;
export type MenuOrderStatus = typeof MenuOrderStatus[keyof typeof MenuOrderStatus];


export function instanceOfMenuOrderStatus(value: any): boolean {
    for (const key in MenuOrderStatus) {
        if (Object.prototype.hasOwnProperty.call(MenuOrderStatus, key)) {
            if (MenuOrderStatus[key as keyof typeof MenuOrderStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MenuOrderStatusFromJSON(json: any): MenuOrderStatus {
    return MenuOrderStatusFromJSONTyped(json, false);
}

export function MenuOrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderStatus {
    return json as MenuOrderStatus;
}

export function MenuOrderStatusToJSON(value?: MenuOrderStatus | null): any {
    return value as any;
}

export function MenuOrderStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MenuOrderStatus {
    return value as MenuOrderStatus;
}

